module.exports = __webpack_public_path__ + "static/media/mimi3.477fc8dd.gif";